import React, { useEffect, useMemo, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import arrOfShare from "../../../../configs/shareTelvAffiliate";
import { makeUrl } from "../../../../Helper/Helper";
import { BsQrCodeScan } from "react-icons/bs";
import { IoCopy } from "react-icons/io5";
import QRCodeGenerator from "./QRCodeGenerator";
import "./style.css";
import { usePresale } from "../../../../scripts/usePresale";

function Share() {
  const [smShow, setSmShow] = useState(false);
  const { address, userInfo, verifyReferrer } = usePresale();

  const [canShare, setCanShare] = useState(false);
  const totalShares = Number(userInfo?.totalShares || 0);
  const totalPower = totalShares / 1_000_000;

  useEffect(() => {
    if (!address) {
      setCanShare(false);
      return;
    }
    if (totalShares < 15) {
      setCanShare(false);
      return;
    }
    let cancelled = false;
    (async () => {
      const result = await verifyReferrer(address);
      if (!cancelled) {
        setCanShare(result);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [address, totalShares, verifyReferrer]);

  const shareUrl = useMemo(() => {
    if (!canShare || !address) return "";
    return makeUrl({ sponsor: address });
  }, [address, canShare]);

  const shareTitle = "Join the Trinity private sale";

  return (
    <Row className="bg-live align-items-center justify-content-center shared-margin shared-space">
      <Col xs={10} className="live-buy-section live-buy-sectionCard">
        <Row className="shares-stats-row">
          <Col md={4} className="share-stat-card">
            <h3 className="share-stat-title">
              Your <span className="purple-span">shares</span>
            </h3>
            <p className="share-stat-value">{totalShares.toLocaleString()}</p>
          </Col>
          <Col md={4} className="share-stat-card">
            <h3 className="share-stat-title custome-title">
              Your <span className="purple-span">Power</span>
            </h3>
            <p className="share-stat-value custome-value">
              {totalPower.toFixed(6)}
            </p>
            {/* <div className="share-progress-container">
              <div
                className="share-progress-bar"
                style={{
                  width: `${Math.min(totalPower * 10, 100)}%`,
                }}
              ></div>
            </div> */}
          </Col>
          <Col md={4} className="share-stat-card">
            <h3 className="share-stat-title custome-title">
              Total <span className="purple-span">Profit</span>
            </h3>
            <p className="share-stat-value custome-value">
              {canShare ? "Verified" : "0.00 TRT"}
            </p>
            <div className="share-progress-container">
              <div
                className="share-progress-bar"
                style={{ width: canShare ? "100%" : "10%" }}
              ></div>
            </div>
          </Col>
        </Row>

        <Modal
          size="sm"
          show={smShow}
          onHide={() => setSmShow(false)}
          aria-labelledby="example-modal-sizes-title-sm"
          centered
          className="smShowModal"
        >
          <Modal.Body>
            <QRCodeGenerator url={shareUrl} />
          </Modal.Body>
        </Modal>

        {totalShares >= 15 ? (
          <div className="second-row-in-share">
            <div className="share-link">
              {canShare ? (
                arrOfShare(shareUrl, shareTitle).map(({ onClick }, index) => (
                  <p key={index} onClick={onClick}>
                    {shareUrl}
                  </p>
                ))
              ) : (
                <p>
                  Your account must be verified on-chain to share a referral
                  link.
                </p>
              )}
            </div>
            <div className="share-btns">
              {canShare &&
                arrOfShare(shareUrl, shareTitle).map(({ onClick }, index) => (
                  <React.Fragment key={index}>
                    <IoCopy className="cursor-pointer" onClick={onClick} />
                    <BsQrCodeScan
                      onClick={() => setSmShow(true)}
                      className="BsQrCodeScan"
                    />
                  </React.Fragment>
                ))}
            </div>
          </div>
        ) : (
          <div className="second-row-in-share">
            <p className="share-link text-center mb-0">
              Gain instant commissions if you own more than 15 shares.
            </p>
          </div>
        )}
      </Col>
    </Row>
  );
}

export default Share;
